import { render, staticRenderFns } from "./CheckUp.vue?vue&type=template&id=10233525&scoped=true"
import script from "./CheckUp.vue?vue&type=script&lang=js"
export * from "./CheckUp.vue?vue&type=script&lang=js"
import style0 from "./CheckUp.vue?vue&type=style&index=0&id=10233525&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10233525",
  null
  
)

export default component.exports